import "owl.carousel";

const navIcons = [
    '<i class="lni lni-arrow-left-circle"></i>',
    '<i class="lni lni-arrow-right-circle"></i>'
];

$(document).ready(function() {
    $("#slide-carousel").owlCarousel({
        margin: 0,
        nav: false,
        navText: navIcons,
        dots: true,
        items: 1,
        loop: true,
        autoplay: false,
        //autoplayTimeout: 3000,
        autoplayHoverPause: true,
        //lazyLoad: true
    });

    $("#columns-carousel").owlCarousel({
        margin: 30,
        nav: true,
        navText: navIcons,
        dots: false,
        items: 3,
        loop: false,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        responsive: {
            0: {
                items: 1,
                nav: false,
                dots: true
            },
            768: {
                items: 3,
                nav: true
            }
        }
    });

    $(".gallery-carousel").owlCarousel({
        margin: 30,
        nav: false,
        navText: navIcons,
        dots: true,
        items: 1,
        loop: true
        /* autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true */
    });

    $("#bar-carousel").owlCarousel({
        margin: 0,
        nav: true,
        navText: navIcons,
        dots: false,
        items: 1,
        loop: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
    });
});
